import {encodeBase64Url} from './encodeBase64Url';
import {generatePkceChallenge} from './generatePkceChallenge';

const PKCE_RANDOM_BYTES = 32;
const PKCE_CHALLENGE_METHOD = 'S256';

export const generateOAuthFlow = async () => {
  const verifier = encodeBase64Url(crypto.getRandomValues(new Uint8Array(PKCE_RANDOM_BYTES)));
  const challenge = await generatePkceChallenge(verifier);
  return {verifier, challenge, challengeMethod: PKCE_CHALLENGE_METHOD, state: crypto.randomUUID()};
};
